// Gemeinsame Typen des Teilsystems Mail (Bereich `mail`).
/** Was für eine Mail das ist (von der KI oder einfachen Regeln erkannt). */
export const MAIL_ARTEN = ['rechnung', 'angebot', 'einnahme', 'aufgabe', 'info', 'werbung'];
export const MAIL_ART_NAMEN = {
    rechnung: 'Rechnung',
    angebot: 'Kostenvorschlag / Angebot',
    einnahme: 'Einnahme',
    aufgabe: 'Aufgabe',
    info: 'Info',
    werbung: 'Werbung',
};
export const MAIL_ZUORDNUNG_NAMEN = {
    plus: 'über die Plus-Adresse',
    ki: 'von der KI vorgeschlagen',
    hand: 'von Hand zugeordnet',
    offen: 'noch nicht zugeordnet',
};
/** Gmail-Vorgaben für „Konto hinzufügen“. */
export const MAIL_GMAIL = { host: 'imap.gmail.com', port: 993 };
//# sourceMappingURL=mail.js.map